<template>
  <div class="card orange">
    <div class="content">
      <div class="header">
        {{ $tc('TABLE', 1) | capitalize }}
        <i class="right floated table icon"></i>
      </div>
      <div class="meta">
        {{ $t('TABLE_META', {}) }}
      </div>
    </div>
    <div class="primary content">
      <!-- Show warning if the table is large - this may cause a lot of network traffic -->
      <div class="ui tiny warning message" v-if="currentTableRowCount > 1000">
        <i class="warning icon"></i>
        {{ $t('TABLE_VERY_LARGE_WARNING') }}
      </div>

      <div class="field">
        <typeahead
          :multiple="false"
          :current-item="currentTable"
          :items="allTables"
          :label-text="$tc('TABLE', 1) | capitalize"
          :placeholder-text="$tc('TABLE', 1) | capitalize"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('TABLE', 2) })"
          :select-handler="tableSelected"
          :disabled="isEditDisabled"
        >
          <template slot="selected" slot-scope="props">
            <span class="text">{{ props.item.name }}</span>
          </template>
          <template slot="dropdown" slot-scope="props">
            <span class="description">{{ $tc('ROW', countRows(props.item)) }}</span>
            <span class="text">{{ props.item.name }}</span>
          </template>
        </typeahead>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../../scss/variables';
.info.message,
.warning.message {
  display: block !important;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Typeahead, Typenames } from 'ui'
import { Table } from 'services'

export default {
  name: 'tabletrigger',
  components: { Typeahead },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          externalType: 'TABLE',
          configuration: {
            tableId: ''
          }
        }
      }
    }
  },

  computed: {
    allTables() {
      return this.$store.state.table.items
    },
    currentTable() {
      const tableId = this.trigger.configuration.tableId
      return this.nameOfTable(tableId)
    },
    isEditDisabled() {
      return this.$store.state.flowEditor.isFlowEditingDisabled
    }
  },

  methods: {
    countRows(table: Object) {
      return Math.max(0, _.split(table.csv, '\n', 100000).length - 1)
    },
    tableSelected(table: Object) {
      this.trigger.configuration.tableId = table.id
      this.currentTableRowCount = countRows(table)
    },
    nameOfTable(tableId: string): string {
      let table = _.find(this.allTables, t => t.id === tableId)
      return (table && table.name) || tableId
    }
  },

  data() {
    return {
      currentTableRowCount: 0,
      tablesPromise: null
    }
  },

  created() {
    this.tablesPromise = Table.readAllTables()
  }
}
</script>
